import { Reveal } from "./Reveal";

const TOOLS = [
  "Zoho One",
  "Zoho CRM",
  "Zoho Projects",
  "Zoho Books",
  "QuickBooks",
  "Microsoft 365",
  "Google Workspace",
  "Excel",
  "Autodesk",
];

export default function ToolsStrip() {
  return (
    <section className="py-12 lg:py-16 bg-white border-b border-slate-100">
      <div className="max-w-5xl mx-auto px-4 sm:px-8 text-center">
        <Reveal>
          <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-brand-grey font-semibold mb-6">
            Working quietly inside the tools you already use
          </p>
          <div
            data-testid="tools-strip"
            className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3"
          >
            {TOOLS.map((t) => (
              <span
                key={t}
                data-testid={`tool-${t.toLowerCase().replace(/\s+/g, "-")}`}
                className="font-display font-semibold text-sm sm:text-base uppercase tracking-[0.08em] text-slate-400 transition-colors duration-300 hover:text-brand-teal"
              >
                {t}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
